module.exports = __webpack_public_path__ + "website/img/yoyo8.fff9ed34.jpg";